<template>
    <div class="p-4 bg-white rounded-[19px] shadow flex-col justify-start items-start gap-3 inline-flex sm:p-6">
        <div class="self-stretch">
            <div class="flex flex-wrap justify-between gap-1 md:gap-0">
                <div>
                    <div class="text-slate-700 text-xl font-extrabold">
                        <slot name="title"></slot>
                    </div>
                    <div v-if="$slots.subtitle" class="text-slate-400 text-sm font-normal">
                        <slot name="subtitle"></slot>
                    </div>
                </div>
                <div>
                    <vx-tabs v-model="mode" size="sm" role="tablist" aria-label="Raw or pretty">
                        <vx-tab
                            value="raw"
                            :id="rawTabId"
                            :aria-controls="'raw' === mode ? panelId : undefined"
                            data-test="raw-tab"
                        >
                            Raw
                        </vx-tab>
                        <vx-tab
                            value="pretty"
                            :id="prettyTabId"
                            :aria-controls="'pretty' === mode ? panelId : undefined"
                            data-test="pretty-tab"
                        >
                            Pretty
                        </vx-tab>
                    </vx-tabs>
                </div>
            </div>
        </div>

        <div v-if="props.truncated" class="text-xs text-amber-600">Data has been truncated.</div>

        <div
            :id="panelId"
            role="tabpanel"
            :aria-labelledby="'raw' === mode ? rawTabId : prettyTabId"
            class="flex flex-col w-full"
        >
            <div
                v-if="'raw' === mode"
                class="w-full px-5 py-3 bg-slate-50 rounded-2xl border border-solid border-slate-200 text-slate-500 text-sm font-normal leading-snug break-all"
            >
                {{ rawContent }}
            </div>
            <div v-else class="w-full">
                <vx-code-editor :modelValue="prettyContent" disabled></vx-code-editor>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { VxTabs, VxTab, VxCodeEditor } from '@voxie/frontend-components';
import { computed, ref, useId } from 'vue';

const props = defineProps<{
    data: unknown;
    truncated?: boolean;
}>();

const mode = ref<'raw' | 'pretty'>('pretty');
const rawTabId = useId();
const prettyTabId = useId();
const panelId = useId();

const rawContent = computed(() => {
    if ('string' === typeof props.data) {
        return props.data;
    }

    return JSON.stringify(props.data);
});

const prettyContent = computed(() => {
    if ('string' === typeof props.data) {
        try {
            return JSON.stringify(JSON.parse(props.data), null, 4);
        } catch {
            return props.data;
        }
    }

    return JSON.stringify(props.data, null, 4);
});
</script>
